import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import { getThemeImages } from '../../../../Themes';
import HintItem from '../HintItem';

import styles from './InitialScreen.Styles';

const InitialScreen = ({ onLearnMorePress, onPrimaryButtonPress, onClosePress }) => {
  const theme = useTheme() || LightThemeColors;
  const images = getThemeImages(theme.name);

  return (
    <View style={styles.contentContainerStyle} testID={FrameworkTestKeys.BLOInitialScreenView}>
      <Icon
        name={images.icNetwork}
        type="image"
        size={101}
        style={styles.networkIconStyle}
        testID={FrameworkTestKeys.BLOInitialIcon}
      />
      <VFText
        i18nKey="background_location_overlay_title"
        style={styles.titleStyle(theme)}
        testKey={FrameworkTestKeys.BLOInitialScreenTitleText}
      />
      <VFText
        i18nKey="background_location_overlay_description"
        style={styles.descriptionStyle(theme)}
        testKey={FrameworkTestKeys.BLOInitialScreenDescriptionText}
      />

      <View
        style={styles.hintsContainerViewStyle}
        testID={FrameworkTestKeys.BLOInitialScreenHintsContainerView}
      >
        <HintItem
          description={'background_location_overlay_first_hint'}
          testID={FrameworkTestKeys.BLOInitialScreenHintItemOne}
        />
        <HintItem
          description={'background_location_overlay_second_hint'}
          testID={FrameworkTestKeys.BLOInitialScreenHintItemTwo}
        />
      </View>
      <TouchableWithoutFeedback
        onPress={onLearnMorePress}
        testID={FrameworkTestKeys.BLOInitialScreenLearnMoreTWF}
      >
        <VFText
          i18nKey="background_location_overlay_learn_more"
          style={styles.learnMoreHyperlinkStyle(theme)}
          testKey={FrameworkTestKeys.BLOInitialScreenLearnMoreText}
        />
      </TouchableWithoutFeedback>

      <VFText
        i18nKey="background_location_overlay_go_to_settings_label"
        style={styles.secondDescriptionStyle(theme)}
        testKey={FrameworkTestKeys.BLOInitialScreenSettingsText}
      />
      <VFText
        i18nKey="background_location_overlay_allow_all_the_time_label"
        style={styles.secondExtraDescriptionStyle(theme)}
        testKey={FrameworkTestKeys.BLOInitialScreenAllowAllText}
      />

      <VFButton
        type="primary"
        title="background_location_overlay_go_to_settings_button_text"
        style={styles.primaryButton}
        onPress={onPrimaryButtonPress}
        testKey={FrameworkTestKeys.BLOInitialScreenSettingsButton}
      />

      <VFButton
        type="secondary"
        title="background_location_overlay_not_now_button_text"
        style={styles.secondaryButton}
        onPress={onClosePress}
        testKey={FrameworkTestKeys.BLOInitialScreenNotNowButton}
      />
    </View>
  );
};

InitialScreen.propTypes = {
  onLearnMorePress: PropTypes.func,
  onPrimaryButtonPress: PropTypes.func,
  onClosePress: PropTypes.func,
};

export default InitialScreen;
